module.exports = __webpack_public_path__ + "static/media/Hippolytus.66fa85a3.jpg";